import { IAnalysisFolder } from "../../pages/dashboardPage/components/fullAnalysis/IAnalysisFolder";
import { IFileProvider } from "./IFileProvider";
import folder1 from "../../assets/folder_filled.svg";
import { linkGoogleWithPopup } from "../api";
import { requestWithProgress } from "../../utils/requestWithProgress";
import { initGapi } from "./gapiLoader";

const initGapiOperation = initGapi();

export class GFileProvider implements IFileProvider{
    onChange: ()=>void;
    onAuthError: (error: any) => void;
    onReady: ()=>void;
    crumbs: IAnalysisFolder[] = [];

    constructor(){
        initGapiOperation.then(result=>{
            this.onReady?.();
        });
    }

    providerName = 'g';

    async connect(){
        return linkGoogleWithPopup().then(tk=>{
            if (!tk?.accessToken){
                console.log('cant connect');
                //setNotConnected(true);
            } else {
                localStorage.setItem('gtoken', tk.accessToken);
                gapi.client.setToken({access_token: localStorage.getItem('gtoken')});
                //setNotConnected(false);
                //this.getFiles();
            }
        });
    }

    async getFiles(folderId?: string, aliasName?: string){
        return this._navigateFolder(folderId, aliasName)
        .then(res=>this.onChange?.())
        .catch(err=>{
            this.onAuthError(err);
        });
    }

    async createFile(file: File, folderId: string, onProgress?:(current: number, total: number)=>void){
        return this._uploadFile(file, onProgress).then(response=>{
            return response.json();
        }).then((result: any)=>{
            return this._moveAndRename(result.id, folderId, file.name);
        }).then(renameResponse=>{
            this._getCurrentFiles();
            console.log(renameResponse.result);
        }).catch(err=>{
            this.onAuthError(err);
        });
    }

    async createFolder(folder: IAnalysisFolder, folderId: string){
        await this._createFolder(folder, folderId);
    }

    async updateFile(file: IAnalysisFolder){
        return this._moveAndRename(file.id, file.parent ?? this.crumbs[this.crumbs.length - 1].id, file.name).then(()=>{this._getCurrentFiles();});
    }

    async deleteFile(fileId: string){
        return gapi.client.request({
            method: 'DELETE',
            path: `https://www.googleapis.com/drive/v3/files/${fileId}`,
        }).then(result=>{
            console.log(result);
            return this._getCurrentFiles();
        }).catch(err=>{
            this.onAuthError(err);
        });
    }

    private _moveAndRename(fileId: string, folderId: string, fileName: string){
        return gapi.client.request({
            method: 'PATCH',
            path: `https://www.googleapis.com/drive/v3/files/${fileId}`,
            params: {
                uploadType: 'media',
                fileId: fileId,
                addParents: folderId,
                removeParents: 'root'
            },
            body: {
                name: fileName,
            },
        });
    }

    private _uploadFile(file: File, onProgress?: (current: number, total: number)=>void){
        const uploadUrl = 'https://www.googleapis.com/upload/drive/v3/files?uploadType=media';
        const headers = {
            'Content-Type': file.type,
            'Content-Length': file.size.toString(),
            'Authorization': 'Bearer '+ localStorage.getItem('gtoken') 
        };
        if (onProgress){
            return requestWithProgress(uploadUrl, file, headers, onProgress);
        } else {
            return fetch(uploadUrl, {
                method: 'POST',
                body: file,
                headers: headers
            });
        }
    };

    private _createFolder(folder: IAnalysisFolder, folderId: string = 'root'){
        const file_metadata = {
            'name' : folder.name || 'test_create',
            'parents' : [folderId || 'root'],
            'mimeType' : 'application/vnd.google-apps.folder'
        }

        const result = gapi.client.request({
            method: 'POST',
            path: `https://www.googleapis.com/drive/v3/files`,
            body: file_metadata,
        });

        return result.then(res=>{
            this._getCurrentFiles();
            return res;
        }).catch(err=>{
            this.onAuthError(err);
        });
    }

    private _getDriveData(folderId: string = 'root'){
        const filesFields = [
            'id',
            'name',
            'parents',
            'mimeType',
            'iconLink',
            'thumbnailLink'
        ];
        return gapi.client.request({
            //path: `https://www.googleapis.com/drive/v3/files?fields=files(id,name,parents,mimeType),kind,nextPageToken&&pageSize=100&&q=mimeType%3D%27application/vnd.google-apps.folder%27+and+%27${folderId}%27+in+parents`,
            path: `https://www.googleapis.com/drive/v3/files?fields=files(${filesFields.join(',')}),kind,nextPageToken&&pageSize=100&&q=%27${folderId}%27+in+parents`,
        });
    }

    private _navigateFolder = (folderId: string = 'root', aliasName?: string)=>{
        if (folderId == this.crumbs[this.crumbs.length - 1]?.id){
            aliasName = this.crumbs[this.crumbs.length - 1]?.name;
        }
        const fname = this.crumbs[this.crumbs.length - 1]?.folderItems?.find(it=>it.id == folderId)?.name;
        const viewFiles: IAnalysisFolder = {
            name: fname || aliasName || (folderId == 'root' ? 'Drive' : folderId),
            id: folderId,
            iconIndex: folderId === 'root' ? 0 : undefined,
            date: new Date(),
            linkProvider: 'g',
            type: 'folder',
            folderItems: [],
            loadingStatus: 'loading'
        };
        const crumbIndex = this.crumbs.findIndex(it=>it.id == folderId || (!folderId && !it.id));
        if (crumbIndex != -1 && this.crumbs.length !=0){
            this.crumbs = this.crumbs.slice(0, crumbIndex + 1);
        //} else if (crumbIndex == this.crumbs.length-1 && this.crumbs.length !=0){
            this.crumbs[crumbIndex] = viewFiles;
        } else {
            this.crumbs.push(viewFiles);
        }
        this.onChange();
        return this._getDriveData(folderId).then(data=>{
            console.log(data.status);
            const files: Array<any> = data.result.files;
            viewFiles.loadingStatus = 'ready';
            const gicon = folder1;
            const validChildren = files.filter(it=> it.mimeType !== 'application/vnd.google-apps.drive-sdk')

            viewFiles.folderItems= validChildren.map((child: any) => ({
                name: child.name,
                id: child.id,
                iconIndex: (child.mimeType === 'application/vnd.google-apps.folder') ? 0 : undefined,
                date: new Date(),
                type: (child.mimeType === 'application/vnd.google-apps.folder') ? 'folder' : 'file'
            })),
            this.onChange();
        }).catch(e=>{
            viewFiles.loadingStatus = 'error';
            this.onChange();
            throw e;
        })
    }

    private async _getCurrentFiles(){
        if (!this.crumbs[this.crumbs.length -1]){
            return;
        }
        return this.getFiles(this.crumbs[this.crumbs.length -1].id);
    }
}